import axios from "axios";

export function updateClaimDetail(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(`/consumer/admin/api/v1/claims/${parameters.uuid}/update-detail`, {
        duration_month: parameters.duration_month,
        end_at: parameters.end_at,
        remark: parameters.remark,
        metadata: parameters.metadata,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
